export const EXPANDABLE_TRANSITION_TIMEOUT = 300;
export const ANNOUNCEMENT_TIMEOUT = 1000;
export const CLEAR_ANNOUNCEMENT_TIMEOUT = 5000;
export const MOBILE_BREAKPOINT = 600;